import React, { useEffect, useReducer } from "react";
import { Reducer } from "./reducer";
import { IAction, IStore } from "./interface";
import { useQuery } from "../hooks";
import { Actions } from "./types";
import { useNavigate } from "react-router-dom";
import { createHmacString } from "../helpers";

const initialState: IStore = {
  branch_name: '',
  branch_id: '',
  branch_logo: '',
  accent_color: '',
  phone: '',
  user: null,
  changeStore: () => {},
}

export const Context = React.createContext<IStore>(initialState)

export const Store: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const query = useQuery()
  const navigate = useNavigate()

  useEffect(() => {
    if (!query.get('branch_name') || !query.get('branch_id')) {
      navigate(-1)
    }
  }, [])

  useEffect(() => {
    const branchId = query.get('branch_id') || ''
    changeStore({
      branch_name: query.get('branch_name') || '',
      branch_id: branchId,
    })

    if (!branchId) {
      return
    }

    // Имя из query — то, что подставила ссылка; логотип и актуальное название
    // страница берёт у бэка, иначе вместо бренда бизнеса висит логотип Sagi.
    const loadBranding = async () => {
      try {
        const token = createHmacString(new Date().getTime().toString())
        const response = await fetch(
          process.env.REACT_APP_API_URL + `/wallet/front/branding?branch_id=${encodeURIComponent(branchId)}`,
          { headers: { Authorization: token } },
        )
        const json = await response.json()
        const data = json.data
        if (!data) {
          return
        }
        changeStore({
          branch_logo: data.logo || '',
          branch_name: data.name || query.get('branch_name') || '',
          accent_color: data.accent_color || '',
        })
        // Акцент раздаём CSS-переменной: кнопки и ссылки Chakra красятся
        // colorScheme'ом, произвольный hex туда не передать.
        if (data.accent_color) {
          document.documentElement.style.setProperty('--sagi-accent', data.accent_color)
        }
      } catch (e) {
        // Оформление — не блокер: без него страница показывает фолбэк Sagi.
      }
    }

    loadBranding()
  }, [])

  const changeStore = (payload: Partial<IStore>) => {
    dispatch({ type: Actions.CHANGE_STORE, payload })
  }

  const [state, dispatch] = useReducer<React.Reducer<IStore, IAction>>(
    Reducer,
    initialState,
  );
  console.log(state, "state")
  return <Context.Provider value={{ ...state, changeStore }}>{children}</Context.Provider>
}